import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "../App.css";
import logoHead from "./logo/cder_logo.png";

export const Login = ({ setAuth }) => {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleChangePassword = (e) => {
    setPass(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // const emailValue = email;
    // const passwordValue = pass;

    try {
      console.log(process.env.REACT_APP_BACKEND_URL);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email,
            pass,
          }),
        }
      );

      const parseRes = await response.json();

      if (parseRes.token) {
        localStorage.setItem("token", parseRes.token);
        // console.log(parseRes.token)
        setAuth(true);

        toast("Accès réussi!");
      } else {
        setAuth(false);
        toast(parseRes);
      }
    } catch (err) {
      console.error(err.message);
    }

    // Update the state of the email and password variables
    setEmail("");
    setPass("");
  };

  return (
    <>
      <div className="  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            Popular Democratic Republic of Algeria Ministry of Higher Education
            & Scienth1ific Research General Directorate for Scientific Research
            and Technological Development
          </p>
        </div>
        <div className="banner-text-2">
          <h5>Renewable Energy Development Center</h5>
        </div>
      </div>
      <div className="topnav container-fluid mb-2">
        <div className="topnav">
          <a href="#"></a>
          <a href="#"></a>
          <a href="#"></a>
          {/* <button className="btn dash-logout"  onClick={e => logout(e)}>Logout</button>  */}
        </div>
      </div>

      <div className="log-in">
        <h1 className="text-center my-5 ">Authentification</h1>

        <form className="log-in-elements" onSubmit={handleSubmit}>
          <label className="form-label" htmlFor="email">
            Email
          </label>
          <input
            className="form-control"
            value={email}
            type="email"
            placeholder="votreEmail@gmail.com"
            id="email"
            name="email"
            onChange={handleChangeEmail}
          />
          <label className="form-label" htmlFor="password">
            Mot de pass
          </label>
          <input
            className="form-control"
            value={pass}
            type="password"
            placeholder="*****"
            id="password"
            name="password"
            onChange={handleChangePassword}
          />
          <button className="btn btn-primary mt-3" type="submit">
            Log in
          </button>

          <Link to={"/register"} className="btn mt-3 p-2 ms-3">
            Je ne possede pas un compte. Je m'enregistre
          </Link>
        </form>
      </div>

      <ToastContainer />
    </>
  );
};
